export default __webpack_public_path__ + "static/media/pr1.94070d45.png";